const modules = {
	title: "Moduler",
};
export default modules;